import { createFileRoute } from "@tanstack/react-router";
import NotFoundPage from "~/components/errors/NotFoundPage";

export const Route = createFileRoute("/_breadcrumbs/not-found-page")({
  component: RouteComponent,
});

function RouteComponent() {
  return <NotFoundPage />;
}
